import { lender_filter_result } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';
import { arrayToQueryParam } from '@axo/shared/util/string';

export function getLenderFilterResults({
  url: { service: baseURL },
  token,
}: IAPI) {
  return (requestIDs: string[]): Promise<lender_filter_result.Response> =>
    send({
      baseURL,
      token,
      path: `/lender-filter-result?${arrayToQueryParam(
        requestIDs,
        'loanRequestID'
      )}`,
      method: 'GET',
    });
}
